import { useState, useEffect } from 'react'
import { decksLoader, deckIdeasLoader } from '../apiCalls'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Stack from 'react-bootstrap/Stack'
import Dropdown from 'react-bootstrap/Dropdown'
import Button from 'react-bootstrap/Button'
import DeckIdeaComp from '../components/deckIdeaComp.js'
import NewDeckComp from '../components/newDeckComp.js'

const ShowDecks = (props) => {
    const user = props.mods.currentUser

    const [newDeckToggle, setNewDeckToggle] = useState(false)
    const [decks, setDecks] = useState([])
    const [deck, setDeck] = useState({})
    const [deckIdeas, setDeckIdeas] = useState({})
    const [deckSelected, setDeckSelected] = useState(false)

    async function getDecks() {
        const myDecks = await decksLoader()
        setDecks(myDecks)
    }

    useEffect(() => {
        getDecks()
    }, [])

    function buildDeckList() {
        let deckList = decks.map((value, idx) => {
            function selectDeck() { 
                getDeck(value._id)
                setDeckSelected(true)
                }   
            return (
                <Dropdown.Item key={idx} onClick={selectDeck}>{value.name}</Dropdown.Item>
            )
        })
        return deckList
    }

    async function getDeck(id) {
        let myDeck = await deckIdeasLoader(id)
        setDeck(myDeck)
        setDeckIdeas(myDeck.ideas)
    }


    function buildDeckIdeaList() {
        let deckIdeaList = []
        if (deckIdeas.length > 0) {
            deckIdeaList = deckIdeas.map((value, idx) => {
                return (
                    <div key={idx}>
                        <DeckIdeaComp mods={{value, user, buildDeckIdeaList, deck, getDeck}} />
                    </div>
                )
            })
        } else {
            deckIdeaList = [ <p key={0} className="text-light">No ideas listed. Add some ideas to this deck from the ideas tab!</p> ] 
        }

        return deckIdeaList
    }

    function handleNewToggle() {
        if (newDeckToggle) {
            setNewDeckToggle(false)
        } else {
            setNewDeckToggle(true)
        }
    }


    return (
        <div className="deckContainer">
            {newDeckToggle ? <NewDeckComp mods={{setNewDeckToggle, getDecks}} /> : null}
            <Row>
                <Col>
                    <Dropdown>
                    <Dropdown.Toggle variant="dark" id="dropdown-basic" className="defaultButton deckButton">
                        Decks
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                        {(decks.length > 0) ? buildDeckList() : <Dropdown.Item>No Decks Available. Make a new one!</Dropdown.Item>}
                    </Dropdown.Menu>
                    </Dropdown>
                </Col>
                <Col>
                    <Button onClick={handleNewToggle} className="btn-dark defaultButton deckButton">New Deck</Button>
                </Col>
            </Row>
            { deckSelected ? 
            <>
            <h3>{deck.name} Ideas:</h3>
            <Row className="deckIdeaRow">
                <Col>
                    <Stack>
                          {buildDeckIdeaList()} 
                    </Stack>
                </Col>
            </Row></> : <Row className="justify-content-center">
            <p className="text-light">Select a Deck</p></Row> }
        </div>
    )
}

export default ShowDecks